export enum DoEventName {
  DoFleetUpdated = 'DoFleetUpdated',
  ShipmentAllocationQueued = 'ShipmentAllocationQueued',
  ShipmentAssigned = 'ShipmentAssigned',
  ShipmentCreated = 'ShipmentCreated',
  ShipmentEdited = 'ShipmentEdited',
  ShipmentReassigned = 'ShipmentReassigned',
  ShipmentStatusUpdated = 'ShipmentStatusUpdated',
}

export const ACTIVITY_LOG_METADATA_MAPPER = (t) => ({
  [DoEventName.DoFleetUpdated]: {
    metadata: {
      fleetReplacementPlateNumber: t('shipment:replacement_fleet'),
    },
  },
  [DoEventName.ShipmentAssigned]: {
    metadata: {
      transporter: t('common:transporter'),
      fleet: t('common:fleet'),
      driver: t('common:driver'),
    },
  },
  [DoEventName.ShipmentEdited]: {
    metadata: {
      actualOvertimeHours: t('shipment:actual_overtime_hours'),
      actualPricingUnit: t('shipment:actual_pricing_unit'),
      cancelReason: t('shipment:cancel_reason'),
      deliveryDate: t('shipment:delivery_date'),
      discount: t('shipment:discount'),
      discountFlatValue: t('shipment:discount_flat_value'),
      discountType: t('shipment:discount_type'),
      driverNotes: t('shipment:driver_notes'),
      discountPercentageMaxAmount: t('shipment:discount_percentage_max_amount'),
      discountPercentageValue: t('shipment:discount_percentage_value'),
      extraHelperAmount: t('shipment:extra_helper_amount'),
      extraHelperPrice: t('shipment:extra_helper_price'),
      insuranceLoadValue: t('shipment:insurance_load_value'),
      insurancePrice: t('shipment:insurance_price'),
      internalNotes: t('shipment:internal_notes'),
      isCancel: t('shipment:is_cancel'),
      originKsuid: t('shipment:origin_id'),
      podReturnAddress: t('shipment:pod_return_address'),
      podReturnPrice: t('shipment:pod_return_price'),
      priceFinal: t('shipment:price_final'),
      priceSuggestion: t('shipment:price_suggestion'),
      productType: t('shipment:product_type'),
      projectKsuid: t('shipment:project_ksuid'),
      shipperKsuid: t('shipment:shipper_ksuid'),
      shipperNotes: t('shipment:shipper_notes'),
      transporterPrice: t('shipment:transporter_price'),
    },
  },
  [DoEventName.ShipmentReassigned]: {
    metadata: {
      transporter: t('common:transporter'),
      fleet: t('common:fleet'),
      driver: t('common:driver'),
    },
  },
});

export default {};
